<div class="edit-tutorial-video-dialog-container">
  <h1>
    {{
      (isEditMode ? 'STAFF.EDIT_TUTORIAL_VIDEO_DIALOG.TITLE' : 'STAFF.TUTORIAL_VIDEOS.ADD_TUTORIAL_VIDEO') | translate
    }}
  </h1>
  <p [innerHTML]="'STAFF.EDIT_TUTORIAL_VIDEO_DIALOG.DESC_1' | translate"></p>
  <p translate="STAFF.EDIT_TUTORIAL_VIDEO_DIALOG.DESC_2"></p>
  <b translate="STAFF.EDIT_TUTORIAL_VIDEO_DIALOG.EXAMPLES"></b>
  <ul>
    <li [innerHTML]="'STAFF.EDIT_TUTORIAL_VIDEO_DIALOG.LI_1' | translate"></li>
    <li [innerHTML]="'STAFF.EDIT_TUTORIAL_VIDEO_DIALOG.LI_2' | translate"></li>
  </ul>

  <gb-form-field
    [control]="target"
    labelTranslateKey="STAFF.EDIT_TUTORIAL_VIDEO_DIALOG.DASHBOARD_PAGE_URL"
  ></gb-form-field>

  <gb-form-field [control]="title" labelTranslateKey="STAFF.EDIT_TUTORIAL_VIDEO_DIALOG.TITLE_FIELD"></gb-form-field>
  <p [innerHTML]="'STAFF.EDIT_TUTORIAL_VIDEO_DIALOG.DESC_3' | translate"></p>

  <gb-form-field
    [control]="video_url"
    labelTranslateKey="STAFF.EDIT_TUTORIAL_VIDEO_DIALOG.YOUTUBE_VIDEO_ID"
  ></gb-form-field>
</div>

<div class="gb-dialog-actions-container gb-flex-button-container">
  <button mat-stroked-button translate="CANCEL" (click)="closeDialog()"></button>
  <button mat-flat-button (click)="submit()" [disabled]="(editCreateLoaded$ | async) === false">
    <gb-button-loader [loaded$]="editCreateLoaded$">
      <span translate="SAVE"></span>
    </gb-button-loader>
  </button>
</div>
